export const IMAGE_HEIGHT = '100px';
export const IMAGE_WIDTH = '80px';
